export default __webpack_public_path__ + "static/media/Glwc.5e99d434.png";